import type { IActiveUserSession } from "../ports/outputs/session";
import { UserRole } from "../global";
import { sessionRoleMatchesAllowList } from "../global/role-session";
import { RBAC_PERMISSIONS } from "./rbac-permission-codes";
import { sessionHasPermission } from "./session-permissions";

export function canReadBillingFromSession(
  session: IActiveUserSession | null,
): boolean {
  return sessionHasPermission(session, RBAC_PERMISSIONS.BILLING_READ);
}

export function canManageBillingFromSession(
  session: IActiveUserSession | null,
): boolean {
  return sessionHasPermission(session, RBAC_PERMISSIONS.BILLING_MANAGE);
}

/** Crear, editar y desactivar planes (alineado con API: solo super administrador). */
export function canManageMembershipPlansFromSession(
  session: IActiveUserSession | null,
): boolean {
  return sessionRoleMatchesAllowList(session?.role, [
    UserRole.SuperAdministrator,
  ]);
}
